import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const getOnlineOrderVoucherCode = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.voucherRequest.code);
